<template>
  <div class="background-01">
     <v-layout row wrap>
      <v-flex xs12 sm2 md2 class="hidden-xs-only ">
        <image-app class="animated fadeInLeft" :imaSize="300" imaSrc="design/banco1-1-3" imaAlt=""></image-app>
      </v-flex>
      <v-flex xs12 sm9 class="animated fadeInUp dura_1">
        <ui-title-one titleAccess="¿Qué es el gasto?" titleLevel="h1">
          <template slot="partOne">¿Qué es<br></template>
          <template slot="partThree"> el gasto?</template>
        </ui-title-one>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 class="text-xs-center">
        <ui-simple-lsc  :vidTittle="'¿Qué es el gasto?'" videoEmbed="ADMINISTRACIONDINERO27QueEsElGasto.mp4"></ui-simple-lsc>
      </v-flex>
      <v-flex xs12 sm5 md5 text-xs-center class="animated fadeIn dura_2">
        <image-app class="animated fadeInLeft" :imaSize="340" imaSrc="contenido/diapositiva_28" imaAlt="Billetera abierta y sin dinero"></image-app>
      </v-flex>
      <v-flex xs12 md6 class="animated fadeInUp dura_2 aligner">
        <p class="text-box adorn-bottom">
          Es la <strong>salida de dinero</strong> que permite a una persona adquirir un artículo o servicio. 
          <strong>Comprar</strong> alimentos, ropa, muebles, carro, pagar matrículas o arriendos, entre otros, 
          son considerados gastos. 
        </p>
      </v-flex>
    </v-layout>

  </div>
</template>

<script>
export default {
  props: {
    modName: {
      type: String,
      required: false
    }
  },
  data() {
    return {};
  },
  mounted() {
    this.$store.commit("nextShow", true);
  }
};
</script>


// WEBPACK FOOTER //
// davivienda-27.vue?24746058